var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contentImage)?_c('div',_vm._g({staticClass:"gc-page__content-image",style:({ backgroundImage: `url(${_vm.contentImage})` })},_vm.$listeners),[_c('img',{staticClass:"gc-page__main-image",attrs:{"src":_vm.contentImage,"alt":"Main Image"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }